import { useNavigate } from 'react-router';
import { DropdownMenu } from 'radix-ui';
import { Check, ChevronsUpDown, Plus } from 'lucide-react';
import { ROLE_LABELS, STAGE_LABELS } from '@seventide/types';
import { useMe } from '../../hooks/useMe';
import { useWorkspace } from '../../hooks/useWorkspace';
import { menuContentClass, menuItemClass } from './menuStyles';

/** Header control: current Principal + stage, and a menu to switch family workspace or set up another. */
export function WorkspaceSwitcher() {
  const { wsId, workspace } = useWorkspace();
  const me = useMe();
  const navigate = useNavigate();
  const workspaces = me.data?.workspaces ?? [];
  const principalName = workspace.principal?.fullName ?? workspace.name;

  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger
        className="flex min-h-11 max-w-full min-w-0 items-center gap-2 rounded-lg px-2 text-left hover:bg-surface-muted"
        aria-label={`Family workspace: ${principalName}, ${STAGE_LABELS[workspace.stage]} stage. Switch workspace`}
      >
        <span className="flex min-w-0 flex-col leading-tight">
          <span className="truncate font-bold">{principalName}</span>
          <span className="truncate text-sm text-muted">{STAGE_LABELS[workspace.stage]} stage</span>
        </span>
        <ChevronsUpDown aria-hidden="true" className="h-5 w-5 shrink-0 text-muted" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="start" sideOffset={6} className={menuContentClass}>
          <DropdownMenu.Label className="px-3 py-2 text-sm font-bold text-muted">Family workspaces</DropdownMenu.Label>
          {workspaces.map((w) => (
            <DropdownMenu.Item key={w.id} className={menuItemClass} onSelect={() => navigate(`/w/${w.id}`)}>
              <span className="inline-flex w-5 justify-center">
                {w.id === wsId && <Check aria-label="Current" className="h-5 w-5" />}
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-bold">{w.principalName ?? w.name}</span>
                <span className="text-sm text-muted">
                  {STAGE_LABELS[w.stage]} stage · {ROLE_LABELS[w.role]}
                </span>
              </span>
            </DropdownMenu.Item>
          ))}
          <DropdownMenu.Separator className="my-1 h-px bg-border" />
          <DropdownMenu.Item className={menuItemClass} onSelect={() => navigate('/onboarding')}>
            <Plus aria-hidden="true" className="h-5 w-5" />
            Set up another family workspace
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
